export const RegionCode = Object.freeze({
    DS: Symbol('DS'),
    KP: Symbol('KP'),
    LB: Symbol('LB'),
    LS: Symbol('LS'),
    LD: Symbol('LD'),
    MP: Symbol('MP'),
    MZ: Symbol('MZ'),
    OP: Symbol('OP'),
    PK: Symbol('PK'),
    PL: Symbol('PL'),
    PM: Symbol('PM'),
    SL: Symbol('ŚL'), // This code must be treated specially because on backend side it is "ŚL"!
    SK: Symbol('SK'),
    WM: Symbol('WM'),
    WP: Symbol('WP'),
    ZP: Symbol('ZP'),
});

/**
 * Results of this method can be used in <v-select> fields.
 */
export function getItems(value = 'value', text = 'text') {
    let items = [];
    const codes = Object.getOwnPropertyNames(RegionCode);

    for (const code of codes) {
        items.push({[value]: code, [text]: getName(code)});
    }

    return items;
}

export function getName(code) {
    if ('ŚL' === code) {
        code = RegionCode.SL;
    }

    return {
        [RegionCode.DS]: 'dolnośląskie',
        [RegionCode.KP]: 'kujawsko-pomorskie',
        [RegionCode.LB]: 'lubelskie',
        [RegionCode.LS]: 'lubuskie',
        [RegionCode.LD]: 'łódzkie',
        [RegionCode.MP]: 'małopolskie',
        [RegionCode.MZ]: 'mazowieckie',
        [RegionCode.OP]: 'opolskie',
        [RegionCode.PK]: 'podkarpackie',
        [RegionCode.PL]: 'podlaskie',
        [RegionCode.PM]: 'pomorskie',
        [RegionCode.SL]: 'śląskie',
        [RegionCode.SK]: 'świętokrzyskie',
        [RegionCode.WM]: 'warmińsko-mazurskie',
        [RegionCode.WP]: 'wielkopolskie',
        [RegionCode.ZP]: 'zachodniopomorskie',
    }[RegionCode[code]];
}
